
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dumVR", function(module, exports) {

$parcel$export(module.exports, "pageParams", function () { return $9d1fdd94a167e3a8$export$e1acdbbe7c24d88; });
$parcel$export(module.exports, "validationVariants", function () { return $9d1fdd94a167e3a8$export$1321ab7f525f446c; });
$parcel$export(module.exports, "assertPageParams", function () { return $9d1fdd94a167e3a8$export$ca425444c95bb4f5; });
$parcel$export(module.exports, "fetchData", function () { return $9d1fdd94a167e3a8$export$8134c072fddab6a5; });

var $1QpD4 = parcelRequire("1QpD4");

var $39Xi6 = parcelRequire("39Xi6");

var $5fxxW = parcelRequire("5fxxW");
const $9d1fdd94a167e3a8$var$MAX_NUMBER_OF_PHOTOS = 3000;
const $9d1fdd94a167e3a8$export$e1acdbbe7c24d88 = {
    resetData: ()=>localStorage.clear(),
    eventName: ()=>localStorage.getItem("eventName"),
    saveEventName: (eventName)=>localStorage.setItem("eventName", eventName),
    homeLink: ()=>localStorage.getItem("locWA"),
    saveHomeLink: (homeLink)=>localStorage.setItem("locWA", homeLink),
    attendeeUid: ()=>localStorage.getItem("attUidWA"),
    saveAttendeeUid: (attendeeUid)=>localStorage.setItem("attUidWA", attendeeUid),
    generatedAttId: ()=>localStorage.getItem("generatedAttId"),
    saveGeneratedAttId: (generatedAttId)=>localStorage.setItem("generatedAttId", generatedAttId)
};
/**
 * @typedef {Object} ValidationVariant
 */ /**
 * Make a validation variant
 *
 * @param isValid {Function}
 * @param message {String}
 * @returns {ValidationVariant}
 */ function $9d1fdd94a167e3a8$var$makeValidationVariant(isValid, message) {
    return {
        isValid: isValid,
        message: message
    };
}
const $9d1fdd94a167e3a8$export$1321ab7f525f446c = {
    isAssignedAttendeeUid: $9d1fdd94a167e3a8$var$makeValidationVariant(()=>$9d1fdd94a167e3a8$export$e1acdbbe7c24d88.attendeeUid() !== null, "AttendeeUid is not assigned in local storage"),
    isSetUpEventName: $9d1fdd94a167e3a8$var$makeValidationVariant(()=>Boolean($9d1fdd94a167e3a8$export$e1acdbbe7c24d88.eventName()), "Invalid event code. Please contact support")
};
function $9d1fdd94a167e3a8$export$ca425444c95bb4f5(validationList) {
    const error = getError();
    if (error) {
        // NOTE: Show error until fixed
        alert(error.message);
        window.location.reload();
    }
    function getError() {
        return validationList.find((validation)=>!validation.isValid());
    }
}
const $9d1fdd94a167e3a8$export$8134c072fddab6a5 = {
    event: async (eventName = $9d1fdd94a167e3a8$export$e1acdbbe7c24d88.eventName())=>{
        const { result: result } = await (0, $1QpD4.findEvent)({
            eventName: eventName,
            basicDataOnly: true
        });
        if (!result) {
            alert((0, $39Xi6.default).eventNotExist(eventName));
            window.location.reload();
        }
        return result;
    },
    photos: async (eventId, attUid = $9d1fdd94a167e3a8$export$e1acdbbe7c24d88.attendeeUid())=>new Promise((resolve, reject)=>{
            (0, $5fxxW.occoApi).photoListRetrieve("attendee_uid", attUid, eventId, null, null, null, $9d1fdd94a167e3a8$var$MAX_NUMBER_OF_PHOTOS, null, null, null, false, null, null, null, null, null, attUid, true, null, null, (err, result)=>{
                if (err) reject(err);
                else resolve(result);
            });
        })
};

});
parcelRegister("39Xi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24d03456b1ab51b6$export$2e2bcd8739ae039; });
var $24d03456b1ab51b6$export$2e2bcd8739ae039 = {
    eventNotExist: (eName)=>`This "${eName}" event name (eName) doesn't exist. Please use right event name`
};

});


parcelRegister("9ttDU", function(module, exports) {

$parcel$export(module.exports, "setLogo", function () { return $6e5dd0eba1fc417f$export$760bdf29584b90d6; });
$parcel$export(module.exports, "setBackground", function () { return $6e5dd0eba1fc417f$export$2e65e79124cca55d; });

var $kca1p = parcelRequire("kca1p");
const $6e5dd0eba1fc417f$export$760bdf29584b90d6 = (src)=>(0, $kca1p.initSetLogo)(".reg-logo__img", "reg-logo__img_hidden", src);
function $6e5dd0eba1fc417f$export$2e65e79124cca55d(src) {
    const body = document.querySelector(".body");
    if (src) body.style.backgroundImage = `url(${src})`;
    else body.classList.add("body_background_second");
}

});

parcelRegister("k6WJg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11ddb937d65101f0$export$2e2bcd8739ae039; });

var $gXGaT = parcelRequire("gXGaT");

var $cLpc9 = parcelRequire("cLpc9");
var $11ddb937d65101f0$export$2e2bcd8739ae039 = (0, $cLpc9.init)((0, $gXGaT.default).init());

});
parcelRegister("gXGaT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afb5c7716582c629$export$2e2bcd8739ae039; });

var $cFQg4 = parcelRequire("cFQg4");
class $afb5c7716582c629$export$2e2bcd8739ae039 {
    static init() {
        return new $afb5c7716582c629$export$2e2bcd8739ae039();
    }
    getCurrentIndex() {
        return Number(localStorage.getItem(this.INDEX_KEY));
    }
    setCurrentIndex(index) {
        localStorage.setItem(this.INDEX_KEY, String(index));
    }
    getList() {
        const parsedJSON = JSON.parse(localStorage.getItem(this.LIST_KEY));
        return parsedJSON.map((0, $cFQg4.makeAccount));
    }
    setList(list) {
        localStorage.setItem(this.LIST_KEY, JSON.stringify(list));
    }
    constructor(){
        this.LIST_KEY = "accountsList";
        this.INDEX_KEY = "accountsCurrentIndex";
        if (!localStorage.getItem(this.LIST_KEY)) localStorage.setItem(this.LIST_KEY, JSON.stringify([]));
        if (!localStorage.getItem(this.INDEX_KEY)) localStorage.setItem(this.INDEX_KEY, "-1");
    }
}

});
parcelRegister("cFQg4", function(module, exports) {

$parcel$export(module.exports, "makeAccount", function () { return $ef77a6bbfa35247b$export$11be4f79df749898; });
$parcel$export(module.exports, "calculateExpiredDate", function () { return $ef77a6bbfa35247b$export$6c5f1943c09e93a1; });

var $cs9W6 = parcelRequire("cs9W6");
const $ef77a6bbfa35247b$export$11be4f79df749898 = ({ attendeeUid: attendeeUid, eventCode: eventCode, eventLogo: eventLogo = "", name: name = "", email: email = "", phoneNumber: phoneNumber = "", regDate: regDate, expiredDate: expiredDate = null })=>({
        attendeeUid: attendeeUid,
        eventCode: eventCode,
        eventLogo: eventLogo,
        name: name,
        email: email,
        phoneNumber: phoneNumber,
        regDate: new Date(regDate),
        expiredDate: expiredDate ? new Date(expiredDate) : null
    });
const $ef77a6bbfa35247b$export$6c5f1943c09e93a1 = (event, attendee)=>event.photo_auto_delete_days ? (0, $cs9W6.addDays)(attendee.created_date, event.photo_auto_delete_days) : null;

});
parcelRegister("cs9W6", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $9c3f8be21b2d09ba$export$dd412b56f1e4d8aa; });
$parcel$export(module.exports, "formatDate", function () { return $9c3f8be21b2d09ba$export$3ae94a2503e890a1; });
function $9c3f8be21b2d09ba$export$dd412b56f1e4d8aa(targetDate, days) {
    const date = new Date(targetDate);
    date.setDate(date.getDate() + days);
    return date;
}
function $9c3f8be21b2d09ba$export$3ae94a2503e890a1(date, userLocale = navigator.language) {
    const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return new Intl.DateTimeFormat(userLocale, options).format(date);
}

});



parcelRegister("cLpc9", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $72bab5247b095f1c$export$2cd8252107eb640b; });

var $cFQg4 = parcelRequire("cFQg4");
function $72bab5247b095f1c$export$2cd8252107eb640b(storage) {
    const subscriptionsOnChangeCurrentIndex = [];
    return {
        addAccount: addAccount,
        updateAccount: updateAccount,
        isExistsAccount: isExistsAccount,
        findIndex: findIndex,
        findIndexByEventCode: findIndexByEventCode,
        getList: getList,
        setCurrentAccount: setCurrentAccount,
        getCurrentAccount: getCurrentAccount,
        getCurrentIndex: getCurrentIndex,
        onChangeCurrentIndex: onChangeCurrentIndex,
        setList: setList
    };
    function addAccount(params) {
        const account = (0, $cFQg4.makeAccount)(params);
        storage.setList([
            account,
            ...getList()
        ]);
    }
    function updateAccount(account) {
        const list = [
            ...getList()
        ];
        const index = list.findIndex((acc)=>acc.attendeeUid === account.attendeeUid && acc.eventCode === account.eventCode);
        if (index > -1) {
            const currentAccount = list[index];
            const updatedAccount = {
                ...currentAccount,
                ...account
            };
            list[index] = updatedAccount;
            storage.setList(list);
        }
    }
    function getCurrentAccount() {
        return getList()[storage.getCurrentIndex()] || null;
    }
    function getCurrentIndex() {
        return storage.getCurrentIndex();
    }
    function setCurrentAccount(index) {
        storage.setCurrentIndex(index);
        subscriptionsOnChangeCurrentIndex.forEach((callback)=>callback(index));
    }
    function onChangeCurrentIndex(callback) {
        subscriptionsOnChangeCurrentIndex.push(callback);
    }
    function getList() {
        return storage.getList();
    }
    function setList(list) {
        storage.setList(list);
    }
    function findIndex({ attendeeUid: attendeeUid, eventCode: eventCode }) {
        return getList().findIndex((account)=>account.attendeeUid === attendeeUid && account.eventCode === eventCode);
    }
    function findIndexByEventCode(eventCode) {
        return getList().findIndex((account)=>account.eventCode === eventCode);
    }
    function isExistsAccount({ attendeeUid: attendeeUid, eventCode: eventCode }) {
        return findIndex({
            attendeeUid: attendeeUid,
            eventCode: eventCode
        }) > -1;
    }
}

});


parcelRegister("62HiO", function(module, exports) {

$parcel$export(module.exports, "initEventOrganisationDataStorage", function () { return $466484f2a9e2e648$export$e0729f1abb635550; });
function $466484f2a9e2e648$export$e0729f1abb635550() {
    return {
        /**
     * Stores organisation domain data in localStorage.
     * If domain values exist, they are stored; if not, they are removed from localStorage.
     *
     * @param {Object} organisation - The organisation object containing domain information
     * @param {string} [organisation.photo_share_domain] - Photo share domain URL
     * @param {string} [organisation.webapp_domain] - Webapp domain URL
     */ storeEventOrganisationData (organisation) {
            if (!organisation || typeof organisation !== "object") return;
            const domainFields = [
                {
                    key: "photo_share_domain",
                    value: organisation.photo_share_domain
                },
                {
                    key: "webapp_domain",
                    value: organisation.webapp_domain
                }
            ];
            domainFields.forEach(({ key: key, value: value })=>{
                if (value && typeof value === "string" && value.trim()) localStorage.setItem(key, value.trim());
                else localStorage.removeItem(key);
            });
        },
        getPhotoShareDomainFromStorage () {
            return localStorage.getItem("photo_share_domain");
        },
        getWebappDomainFromStorage () {
            return localStorage.getItem("webapp_domain");
        },
        hasPhotoShareDomain () {
            return Boolean(localStorage.getItem("photo_share_domain"));
        },
        hasWebappDomain () {
            return Boolean(localStorage.getItem("webapp_domain"));
        }
    };
}

});


var $GZNPG = parcelRequire("GZNPG");

var $QsXqF = parcelRequire("QsXqF");

var $eZmas = parcelRequire("eZmas");

var $dumVR = parcelRequire("dumVR");

var $9ttDU = parcelRequire("9ttDU");

var $6ct87 = parcelRequire("6ct87");

var $k6WJg = parcelRequire("k6WJg");

var $1QpD4 = parcelRequire("1QpD4");

var $cFQg4 = parcelRequire("cFQg4");

var $iP7AU = parcelRequire("iP7AU");

var $62HiO = parcelRequire("62HiO");
const $10d17eb773f2c122$var$eventOrganisationDataStorage = (0, $62HiO.initEventOrganisationDataStorage)();
const { isSetUpEventName: $10d17eb773f2c122$var$isSetUpEventName } = (0, $dumVR.validationVariants);
const $10d17eb773f2c122$var$form = (0, $eZmas.initRegForm)();
async function $10d17eb773f2c122$var$init() {
    var _event_organisation;
    (0, $eZmas.prepareRegPage)();
    (0, $dumVR.assertPageParams)([
        $10d17eb773f2c122$var$isSetUpEventName
    ]);
    (0, $eZmas.initPrivacyPolicyLink)();
    const event = await (0, $dumVR.fetchData).event();
    if (!event) $GZNPG.withScope((scope)=>{
        scope.setTag("module", "registration");
        scope.setLevel("error");
        scope.setContext("localStorage", {
            eventName: localStorage.getItem("eventName")
        });
        $GZNPG.captureException(new Error("Event name is missing in localStorage"));
    });
    const { opts: opts } = event;
    (0, $iP7AU.saveLocParams)({
        orgId: (_event_organisation = event.organisation) === null || _event_organisation === void 0 ? void 0 : _event_organisation.id,
        eventCode: event.name
    });
    await (0, $iP7AU.initLoc)();
    if (event.organisation) $10d17eb773f2c122$var$eventOrganisationDataStorage.storeEventOrganisationData(event.organisation);
    (0, $iP7AU.setTextToElement)("#createAtt", (0, $iP7AU.t)("submit-registration-btn"));
    (0, $9ttDU.setLogo)(opts.webappCustomLogoSrc);
    (0, $9ttDU.setBackground)(opts.webappCustomBackgroundSrc);
    if (opts.webappIsEnabledSMS) $10d17eb773f2c122$var$form.enablePhoneNumber(opts.webappSMSAgreement);
    if ((0, $eZmas.isNeedToShowPrivacy)(opts)) $10d17eb773f2c122$var$form.enableAgreePrivacy();
    $10d17eb773f2c122$var$form.onSubmit(async ({ name: name, email: email, phoneNumber: phoneNumber })=>{
        const { result: attendeeUid } = await (0, $QsXqF.createAttendee)({
            eventCode: event.name,
            name: name,
            email: email,
            phoneNumber: phoneNumber
        });
        if (!attendeeUid) {
            alert((0, $eZmas.getErrorRegFallBecauseOfAttendeeNull)({
                canBeEmailConfirmationProblem: true
            }));
            return;
        }
        const { result: attendee } = await (0, $1QpD4.findAttendeeByUIDAndEventId)(attendeeUid, event.id);
        (0, $k6WJg.default).addAccount({
            attendeeUid: attendeeUid,
            eventCode: event.name,
            eventLogo: opts.webappCustomLogoSrc,
            name: name,
            email: email,
            phoneNumber: phoneNumber,
            regDate: attendee.created_date,
            expireDate: (0, $cFQg4.calculateExpiredDate)(event, attendee)
        });
        (0, $k6WJg.default).setCurrentAccount(0);
        (0, $6ct87.redirectToPage).index({
            rawSearch: window.location.search
        });
    });
}
document.addEventListener("DOMContentLoaded", $10d17eb773f2c122$var$init);


//# sourceMappingURL=reg-user.34f3cc62.js.map
